import classNames from 'classnames/bind';
import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import imgDelete from '../../../assets/images/delete.svg';
import imgEdit from '../../../assets/images/edit-story.png';
import styles from './AnswerTypes.css';
import { DeleteAnswerType } from './DeleteAnswerType';

const cs = classNames.bind(styles);

export class AnswerTypesTableRow extends Component {
  constructor(props, ...args) {
    super(props, ...args);
    this.state = { modalDeleteShow: false };
  }

  render() {
    const modalDeleteClose = () => {
      this.setState({ modalDeleteShow: false });
      // eslint-disable-next-line react/destructuring-assignment
      this.props.update();
    };

    const deleteRow = () => {
      // eslint-disable-next-line react/destructuring-assignment
      if (this.state.modalDeleteShow === true) {
        return (
          <DeleteAnswerType
            // eslint-disable-next-line react/destructuring-assignment
            show={this.state.modalDeleteShow}
            onHide={modalDeleteClose}
            // eslint-disable-next-line react/destructuring-assignment
            obj={this.props.obj}
          />
        );
      }
      return null;
    };

    const { obj, actionEditAnswerType } = this.props;

    return (
      <tr>
        <td>
          {obj.title}
        </td>
        <td>
          {obj.value}
        </td>
        <td>
          {obj.isDefault}
          <div className={cs(obj.isDefault === true ? 'checked' : null, 'circleBox')} />
        </td>
        <td>
          {obj.disabled}
          <div className={cs(obj.disabled === true ? 'checked' : null, 'circleBox')} />
        </td>
        <td className={cs('text-right')}>
          <Button
            onClick={() => actionEditAnswerType(obj)}
            variant="secondary"
            size="sm"
            className="mx-1"
          >
            <img src={imgEdit} className="btnImg" alt="Edit" />
          </Button>
          <Button
            onClick={() => this.setState({ modalDeleteShow: true })}
            variant="secondary"
            size="sm"
            className="mx-1"
          >
            <img src={imgDelete} className="btnImg" alt="Delete" />
          </Button>
          {deleteRow()}

        </td>
      </tr>
    );
  }
}
